<template>
  <v-app v-if="!loading">
    <core-app-bar @toggle-nav="$refs.drawer.toggleNav()" />
    <core-drawer ref="drawer" />
    <core-view />
    <error-handler
      :error="error"
      :snackStyle="'margin-bottom:60px'"
    ></error-handler>
    <core-footer />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Components from "pbas-vue-components";
import ErrorHandler from "./components/ErrorHandler";
import Quill from "quill";

export default {
  components: {
    ErrorHandler,
    ...Components,

    CoreDrawer: () => import("./components/VueMaterialDashboard/core/Drawer"),
    CoreFooter: () => import("./components/VueMaterialDashboard/core/Footer"),
    CoreAppBar: () => import("./components/VueMaterialDashboard/core/AppBar"),
    CoreView: () => import("./components/VueMaterialDashboard/core/View"),
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("plansMembers", ["options"]),
    // ...mapGetters("downloadCenter", ["cmsEnums"]),
  },
  data() {
    return {
      error: null,
      loading: true,
    };
  },
  watch: {
    isLoggedIn: {
      async handler(v) {
        if (v) {
          try {
            // console.log("App: isLoggedIn: ", v)
            await this.getSettings();
            console.log(this.options);
            // await this.getCmsEnums(this.options.Model);
          } catch (error) {
            //console.log("App: options error:", error)
            this.error = error;
          }
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getSettings"]),
    // ...mapActions("downloadCenter", ["getCmsEnums"]),
  },
  mounted() {
    let timeout = undefined;
    this.$router.afterEach((to, from) => {
      this.loading = false;
      document.title = this.$t("globals.app_title");
    });
    var Block = Quill.import("blots/block");

    class ThemeBtn extends Block {}
    ThemeBtn.blotName = "theme-btn";
    ThemeBtn.className = "theme-btn";
    ThemeBtn.tagName = "div";

    Quill.register(ThemeBtn);
  },
};
</script>

<style>
.predetermined {
  background-color: lightblue;
}
.v-tooltip__content {
  max-width: 400px !important;
  width: 400px !important;
}
html {
  overflow: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  /* Remove scrollbar space */
  background: #f1f1f1;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: #36454F;
}
.top-30 {
  padding-top: 30px;
}
.support-exists {
  padding-top: 30px;
  margin-top: 64px !important;
}
.v-btn {
  letter-spacing: 0 !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 7px !important;
}
.v-dialog--scrollable {
  overflow: visible !important;
}
.v-messages {
  min-height: auto !important;
}
table thead th[role="columnheader"] {
  color: #36454F !important;
}

/*
  Added so that the horizontal bar that follows the browser's scroll
  gets properly hidden when the stepper step collapses
*/
.v-stepper__wrapper[style^="height: 0"] {
  display: none;
}

.required label:before {
  content: "* ";
  color: #ff5252;
  font-weight: 900;
}

.v-btn__content .v-icon {
  font-size: 20px !important;
  margin-right: 5px !important;
  margin-left: 0px !important;
}

.v-dialog--scrollable > .v-card > div > .v-card__text {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow-y: auto;
}
.required-label:before {
  content: "* ";
  color: red;
  font-weight: 900;
}
</style>
